import { MIN_TOUCH_TARGET_PX } from '@powerful/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useShellContext } from '../../contexts/shell-context';
import { CONTEUDO_ID } from '../layout/app-shell';

export function ContextSwitcher() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { contexto, podeAlternar, alternar } = useShellContext();

  if (!podeAlternar) return null;

  const destinoProfissional = contexto === 'consumer';
  const rotulo = destinoProfissional
    ? t('nav.switcher.toProfessional')
    : t('nav.switcher.toConsumer');

  const trocar = () => {
    const proximo = alternar();
    const profissional = proximo === 'professional';

    navigate(profissional ? '/dashboard' : '/home');

    requestAnimationFrame(() => {
      document.getElementById(CONTEUDO_ID)?.focus();
    });
  };

  return (
    <div role="group" aria-label={t('nav.switcher.label')}>
      <button
        type="button"
        className="btn btn-ghost btn-sm hit"
        style={{ minHeight: `${MIN_TOUCH_TARGET_PX}px`, minWidth: `${MIN_TOUCH_TARGET_PX}px` }}
        onClick={trocar}
      >
        {rotulo}
      </button>
    </div>
  );
}

/** Região viva persistente: fica acima do roteador para sobreviver à troca completa de shell. */
export function ContextSwitchAnnouncement() {
  const { t } = useTranslation();
  const { anuncio } = useShellContext();

  const texto = anuncio
    ? t(
        anuncio === 'professional'
          ? 'nav.switcher.announcedProfessional'
          : 'nav.switcher.announcedConsumer',
      )
    : '';

  return (
    <span role="status" aria-live="polite" className="sr-only">
      {texto}
    </span>
  );
}
